/* eslint-disable sonarjs/label-has-associated-control */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Global
import React from 'react';
import cx from 'classnames';

/**
 * Simulates a checkbox toggle
 * @param {object} props -
 * @param {boolean} props.value - If enabled or not
 * @param {Function} props.onClick - Handles check to checked
 * @param props.name
 * @param props.className
 * @param props.sizeProps
 * @param props.sizeClass
 * @returns {React.ReactElement} - Toggle slider form element
 */
const Switch = ({ value, onClick, name, className, sizeClass = 'w-6 h-3 after:h-4 after:w-4' }) => {
  return (
    <label className={cx('inline-flex cursor-pointer w-10 h-4', className)}>
      <input
        type="checkbox"
        className="sr-only peer"
        checked={value}
        onClick={onClick}
        name={name}
      />
      <div
        className={cx(
          sizeClass,
          "relative bg-gray-200 rounded-full peer dark:bg-[#B4B9C1] peer-checked:after:translate-x-3/4 rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:-top-0.5 after:-left-0.5 after:shadow-sm after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-[#B4B9C1] peer-checked:bg-[#00CD8F] dark:peer-checked:bg-[#00CD8F]"
        )}
      />
    </label>
  );
};

export default Switch;
